module.exports = new __parcel__URL__("menu.134918ff.svg").toString();